// 只合并同一身份下同时发生的只读请求；完成或失败后立即释放，不缓存权限或业务结果。
const pending=new Map<string,Promise<any>>()
export function coalesceRead<T>(key:string,load:()=>Promise<T>):Promise<T>{
 const existing=pending.get(key)
 if(existing)return existing
 const task=Promise.resolve().then(load)
 pending.set(key,task)
 const clear=()=>{if(pending.get(key)===task)pending.delete(key)}
 task.then(clear,clear)
 return task
}
